import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress, Typography, Button } from '@mui/material';
import { canApproveRequests } from '../utils/permissions';

/**
 * Route protection for pages accessible by Admin and Manager
 * Used for: AdminRequestsPage (Quản lý yêu cầu)
 */
export default function ManagerRoute({ children }) {
    const { currentUser, loading } = useAuth();

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <CircularProgress />
            </Box>
        );
    }

    if (!currentUser) {
        return <Navigate to="/login" />;
    }

    // Allow access if user can approve requests (admin or manager)
    if (!canApproveRequests(currentUser)) {
        return (
            <Box sx={{ textAlign: 'center', mt: 10 }}>
                <Typography variant="h4">Truy cập bị từ chối</Typography>
                <Typography>Bạn không có quyền truy cập vào trang này.</Typography>
                <Button onClick={() => window.history.back()}>Quay lại</Button>
            </Box>
        );
    }

    return children;
}
